import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { imageUrl } from '../lib/images';

const images = [
  {
    url: "/_assets/th-skovservice-skovarbejde-naturpleje-mors-thy-1.jpg",
    alt: "TH Skovservice - Professionel skovservice og naturpleje på Mors og i Thy"
  },
  {
    url: "/_assets/th-skovservice-traefaeldning-maskiner-mors-thy-2.jpg",
    alt: "Moderne maskiner og udstyr til træfældning og skovarbejde - TH Skovservice"
  },
  {
    url: "/_assets/th-skovservice-skovservice-udstyr-mors-thy-3.jpg",
    alt: "Effektiv træpleje, fældning og naturpleje i Karby, Thisted, Skive og Thy"
  }
];

export default function HeroCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="absolute inset-0 z-0">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          className="absolute inset-0"
        >
          <img 
            src={imageUrl(images[currentIndex].url, 'width=1920,quality=85,format=auto')} 
            alt={images[currentIndex].alt} 
            className="w-full h-full object-cover scale-105"
          />
        </motion.div>
      </AnimatePresence>
      <div className="absolute inset-0 bg-stone-900/40" />
      
      {/* Indikatorer */}
      <div className="absolute bottom-10 right-10 z-20 flex gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-12 h-1 transition-all duration-300 ${
              index === currentIndex ? 'bg-emerald-500' : 'bg-white/30 hover:bg-white/50'
            }`}
            aria-label={`Gå til slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
